<template>
  <div id="about-page-container" class="about-page" v-if="!isLoading">
    <c-banner-about/>
    <c-contact-about/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cBannerAbout from '../../components/about/AboutBanner.vue'
import cContactAbout from '../../components/about/AboutContent.vue'

export default {
  name: 'About',
  components: {
    cBannerAbout,
    cContactAbout
  },
  mounted () {
    const hasVisitedBefore = localStorage.getItem('hasVisitedBefore')

    if (!hasVisitedBefore) {
      this.actionPreloader(true)

      localStorage.setItem('hasVisitedBefore', 'true')

      setTimeout(() => {
        this.actionPreloader(false)
      }, 2000)
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
<style lang="scss" scoped>
  #about-page-container{
    padding-top: 96px;
  }
</style>
